import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_PRIVATE_EQUITY_FILTER } from "src/pages/Dashboard/components/FinaTable/Columns/privateEquity/statusFilter";

export interface FinaTableFilter {
  positions: string;
  transactions: string;
  private_equity: string;
}

const initialState: FinaTableFilter = {
  positions: "OPEN",
  transactions: "ALL",
  /* Live orders only, by default; "All" adds the cancelled ones. */
  private_equity: DEFAULT_PRIVATE_EQUITY_FILTER,
};

const slice = createSlice({
  name: "tableFilters",
  initialState,
  reducers: {
    setPositionsFilter: (state: FinaTableFilter, action) => {
      state.positions = action.payload.filter;
    },
    setTransactionsFilter: (state: FinaTableFilter, action) => {
      state.transactions = action.payload.filter;
    },
    setPrivateEquityFilter: (state: FinaTableFilter, action) => {
      state.private_equity = action.payload.filter;
    },
  },
});

export const {
  setPositionsFilter,
  setTransactionsFilter,
  setPrivateEquityFilter,
} = slice.actions;

export default slice.reducer;
